import { API_TBase } from "./API";

export type API_TCompany = {
  CompanyProfile: TCompanyProfile;
  subscription_status: API_TSubscriptionStatus;
  compliance_package: API_TCompliancePackage;
  compliance_status: API_TComplianceStatus;
  subscription_end_date: string;
  subscription_start_date: string;
  trial_date_end: string;
  trial_date_start: string;
} & API_TBase;

export type TCompanyProfile = {
  name: string;
};

// compliance_package
export const CompliancePackage = {
  Basic: "Basic",
  BasicPlus: "Basic Plus",
  Premium: "Premium",
  Empty: "-",
} as const;

export type API_TCompliancePackage = typeof CompliancePackage[keyof typeof CompliancePackage];

// subscription_status
export const SubscriptionStatus = {
  Trial: "Trial",
  Active: "Active",
  Blocked: "Blocked",
} as const;

export type API_TSubscriptionStatus = typeof SubscriptionStatus[keyof typeof SubscriptionStatus];

// compliance_status
export const ComplianceStatus = {
  Undetermined: "undetermined",
  Compliant: "compliant",
  NotCompliant: "not_compliant",
} as const;

export type API_TComplianceStatus = typeof ComplianceStatus[keyof typeof ComplianceStatus];

export const CompliancePackageLabel = {
  Trial: "Trial",
  Basic: "Basic",
  Standard: "Standard",
  Premium: "Premium",
} as const;

export type TCompliancePackageLabel = typeof CompliancePackageLabel[keyof typeof CompliancePackageLabel];
